import React from "react"

import { Link } from "gatsby"

const BtnLink = ({ data, classes, children }) => {
    
    const renderLink = () => {
        let url = data && data.link && data.link.uri ? data.link.uri : ''
        const isAbsolute = url.includes('http')
        if (isAbsolute === true) {
            return (
                <a href={url} target="_blank" className={classes}>
                    {data?.link?.title ?
                        data.link.title
                        :
                        children
                    }
                </a>
            )
        } else {
            let to;
            if (data && data.link && data.link.uri && data.link.uri.includes('internal:')) {
                const arr = data.link.uri.split('internal:')
                if (arr && arr.length) {
                    to = arr[1]
                } else return null
            } else if (data && data.link && data.link.uri) {
                to = data.link.uri;
            } else return null
            
            return (
                <Link to={to} className={classes}>
                    {children ? children : (
                        data?.link?.title ? data.link.title : ''
                    )}
                </Link>
            )
        }
    }

    return (
        renderLink()
    )
}

export default BtnLink
